import Vue from 'vue'
import Vuex from 'vuex'
import pages from '@/store/pages'
import search from '@/store/search'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    pages,
    search
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js